import React, { useEffect } from "react";
import './assets/CSS/bootstrap-5-48-LGO.css';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Layout from "./components/MainComponents/Layout/layout.component";
import Login from "./components/MainComponents/Login/login.component";
import 'react-datepicker/dist/react-datepicker.css';


import { AccountProvider } from "./Contexts/main.context";
import ClientLayout from "./components/Client/ClientDashboard.component";
import { ClientProvider } from "./Contexts/client.context";

const AppRouter = () => {
     const navigate = useNavigate();
     const location = useLocation();

     useEffect(() => {
          const userToken = localStorage.getItem("LGOUser");

          if (location.pathname === "/login") return; // ✅ Stay on login page if already there

          if (userToken && typeof userToken === 'string') {
               try {
                    const decoded = jwtDecode(userToken);
                    const currentTime = Math.floor(Date.now() / 1000);

                    if (decoded.exp && decoded.exp > currentTime) {
                         if (decoded.security === 'Client') {
                              navigate('/clientDashboard');
                              return;
                         }
                         // ✅ Token is valid, allow access
                         navigate("/dashboard");
                    } else {
                         // ❌ Token expired
                         localStorage.removeItem("LGOUser");
                         navigate("/login");
                    }
               } catch (error) {
                    // ❌ Token is invalid
                    localStorage.removeItem("LGOUser");
                    navigate("/login");
               }
          } else {
               // ❌ No token found
               navigate("/login");
          }

          // eslint-disable-next-line
     }, []);


     return (
          <Routes>
               <Route path="/" element={<Login />} /> {/* 👈 Must have this */}
               <Route path="/dashboard" element={<Layout />} />
               <Route path="/clientDashboard" element={<ClientLayout />} />
               <Route path="/login" element={<Login />} />
          </Routes>
     );
};

const App = () => (
     <AccountProvider>
          <ClientProvider>
               <Router>
                    <AppRouter />
               </Router>
          </ClientProvider>
     </AccountProvider>
);

export default App;
